

































import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { mdiPlay } from '@mdi/js'
import { PRODUCTS_API } from '~/assets/config/api-path'
import { IVideoItem } from '~/assets/interfaces/video'
import MixinGeneral from '~/assets/mixins/general'
import ComponentImage from '~/components/images/image.vue'
import ComponentIcon from '~/components/icon/icon.vue'

@Component({
  components: {
    ComponentImage,
    ComponentIcon,
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentVideo: () => import('~/components/video/video.vue'),
  },
})
export default class ComponentImageVideo extends mixins(MixinGeneral) {
  @Prop({ type: Number, default: -1 }) readonly productId!: number

  private item: IVideoItem | null = null
  private mdiPlay = mdiPlay
  private isShowVideo = false

  private async getItem() {
    this.item = await this.$axios.$get(
      PRODUCTS_API + '/' + this.productId + '/video'
    )
  }

  private async created() {
    await this.getItem()
  }
}
